const ValidStates = {
  Valid: 'Valid',
  Invalid: 'Invalid',
  NotSet: 'NotSet',
};

export default ValidStates;
